import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

const ProtectedRoute = ({ children, ...rest }) => {
  const { auth } = useSelector((state) => state);

  return (
    <Route
      {...rest}
      render={({ location: { state } }) => {
        return auth?.ok ? <Redirect to={state?.from || '/'} /> : children;
      }}
    />
  );
};

export default ProtectedRoute;
